import React from 'react'
import { useTranslation } from 'react-i18next'
import { AppUseDispatch, AppUseSelector } from '../../../redux/hooks'
import { SET_LANGUAGE_INFO, SET_PREFERENCE_TYPE } from '../../../redux/types'
import { SaveCharacter } from '../../../redux/actions/myAccountAction'
import { characterConst } from '../../../utils/constant'
import { trackOnboarding } from '../../../utils/analytics'
import { Glyph } from './icons'
import { StepTitle, StepSubtitle } from '../stepContext'

const SAMPLES: Record<string, string> = {
  'Simplified Chinese': '汉',
  'Traditional Chinese': '漢',
}

// The server names each script in English; these are the names people read.
const SCRIPT_NAMES: Record<string, string> = {
  'Simplified Chinese': 'onboarding:writing.simplified.name',
  'Traditional Chinese': 'onboarding:writing.traditional.name',
}

const WritingStep = ({ next }: { next: () => void }) => {
  const { t } = useTranslation('onboarding')
  const dispatch = AppUseDispatch()
  const { languageInfo, preferenceType } = AppUseSelector(({ onboarding }) => onboarding)

  const select = (preference: any) => {
    const preferences = languageInfo?.preferences?.map((p: any) => ({ ...p, is_active: p._id === preference._id }))
    dispatch({ type: SET_LANGUAGE_INFO, payload: { ...languageInfo, preferences } })
    dispatch({ type: SET_PREFERENCE_TYPE, payload: preference?.preference })
    trackOnboarding('writing_method_selected', { writing_method: preference?.preference })
    // The account already exists by the time this is asked — the email gate
    // runs first — so the choice has to be written to it directly or every
    // Traditional reader would silently keep the Simplified default.
    if (localStorage.getItem('authToken')) {
      SaveCharacter({
        UpdateCharacter: preference?.preference?.includes('Traditional')
          ? characterConst.traditional
          : characterConst.simplified,
      })
    }
    next()
  }

  return (
    <div className='ob-step'>
      <StepTitle>{t('writing.title')}</StepTitle>
      <StepSubtitle>{t('writing.subtitle')}</StepSubtitle>
      <div className='ob-options ob-options--2col'>
        {languageInfo?.preferences?.map((preference: any) => (
          <button
            key={preference?._id}
            type='button'
            className={`ob-option ${preferenceType === preference?.preference ? 'is-selected' : ''}`}
            onClick={() => select(preference)}
          >
            <Glyph char={SAMPLES[preference?.preference] || preference?.word?.charAt(0) || '字'} />
            <span className='ob-option-body'>
              {SCRIPT_NAMES[preference?.preference] ? t(SCRIPT_NAMES[preference.preference]) : preference?.preference}
              <span className='ob-option-hint'>
                {preference?.preference?.includes('Traditional')
                  ? t('writing.traditional.hint')
                  : t('writing.simplified.hint')}
              </span>
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}

export default WritingStep
